import { useState, useEffect } from "react"
import moment from "moment"
import "./ApprovedClaims.css"
import axios from "axios"
import toast from "react-hot-toast"
import { IconButton } from "@mui/material"
import { X } from "lucide-react"

const ApprovedClaims = () => {
  const [claims, setClaims] = useState([])
  const [allClaims, setAllClaims] = useState([]);
  const [search, setSearch] = useState("")
  const [contentReportsLoaded, setContentReportsLoaded] = useState(false)
  const [selectedClaim, setSelectedClaim] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [refreshing, setRefreshing] = useState(false);



  useEffect(() => {
    if (JSON.parse(localStorage.getItem("userData")).id) {
      getApprovedClaims();
    }
  }, []);

  const getApprovedClaims = async () => {
    const therapistId = JSON.parse(localStorage.getItem("userData")).id;
    const token = JSON.parse(localStorage.getItem("userData")).token;
    axios.defaults.headers.common["Authorization"] = token;

    try {
      const res = await axios.post(window.ajaxLink + "stedi/getClaimsData", { therapistId });
      const data = res.data.responseData?.data || [];

      setAllClaims(data);
      setClaims(data);
      setContentReportsLoaded(true);
    } catch (err) {
      console.error(err);
      toast.error("Failed to fetch claims");
      setContentReportsLoaded(true);
    } finally{
      setRefreshing(false)
    }
  };


  useEffect(() => {
    let filteredClaims = allClaims
    if (search?.length > 2) {
      filteredClaims = filteredClaims.filter((claim) => claim.patient_name.toLowerCase().includes(search.toLowerCase()))
      setClaims(filteredClaims)
    } else {
      setClaims(allClaims)
    }

  }, [search])


  const handleRowClick = (claim) => {
    setSelectedClaim(claim)
    setIsModalOpen(true)
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setSelectedClaim(null)
  }

  return (
    <>
      <div className="dash_box_menu rpt_box_menu" style={{ marginBottom: "10px", gap: "10px", display: 'flex', justifyContent: 'space-between' }}>
        <div className="dash_box_search_hold" style={{ maxWidth: "500px" }}>
          <input
            type="text"
            placeholder="Enter Patient name..."
            className="dash_box_search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="dash_box_search_icon"></div>
        </div>


        <div className="programs_new_btn top_hold_btn"
          onClick={async () => {
            setRefreshing(true);
            await getApprovedClaims()
          }}
          style={refreshing || !contentReportsLoaded ?
            {
              cursor: 'not-allowed',
              background: '#9e9e9e'
            }
            :
            {}
          }>
          {refreshing ? "Refreshing List..." : "Refresh List"}
        </div>
      </div>

      <div className="table_scrollable_container_new">
        <div className="table_scrollable_inner_container">
          <div className="programs_table">
            <div className="programs_cols programs_header_row programs_tbl_row" style={{ border: "none" }}>
              <div className="programs_col_info">
                <div className="programs_col_name">Patient</div>
              </div>
              <div className="programs_col_info" style={{ flex: 0.7 }}>
                <div className="programs_col_name">CPT</div>
              </div>
              <div className="programs_col_info" style={{ flex: 0.7 }}>
                <div className="programs_col_name">Date</div>
              </div>
              <div className="programs_col_info" style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="programs_col_name">Status Code</div>
              </div>
              <div className="programs_col_info" >
                <div className="programs_col_name">Status Explanation</div>
              </div>
              <div className="programs_col_info" style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="programs_col_name">Action</div>
              </div>
            </div>
          </div>
          <div className="tbl_content_hold">
            {contentReportsLoaded && !refreshing ? (
              claims.length > 0 ? (
                claims.map((claim) => (
                  <div key={claim.id} className="programs_tbl_row">
                    <div className="programs_tbl_col_contain">
                      <div className="programs_tbl_col">{claim.patient_name ?? "N/A"}</div>
                    </div>
                    <div className="programs_tbl_col_contain" style={{ flex: 0.7 }}>
                      <div className="programs_tbl_col">{claim.cpt_code ?? "N/A"}</div>
                    </div>
                    <div className="programs_tbl_col_contain" style={{ flex: 0.7 }}>
                      <div className="programs_tbl_col">{claim.status_updated_at ? moment(claim.status_updated_at).format("l") : "N/A"}</div>
                    </div>
                    <div className="programs_tbl_col_contain" style={{ display: 'flex', justifyContent: 'center' }}>
                      <div className="programs_tbl_col">{claim.status_code ?? "N/A"}</div>
                    </div>
                    <div className="programs_tbl_col_contain">
                      <div className="programs_tbl_col">{claim?.status_update === "Pending" ? "PENDING" : claim.status_explanation ?? "N/A"}</div>
                    </div>

                    <div className="programs_tbl_col_contain" style={{ display: 'flex', justifyContent: 'center' }}>
                      <div className="programs_tbl_col">
                        <div className="action_btn" onClick={() => {
                          if (claim?.status_update !== "Pending") {
                            handleRowClick(claim)
                          }
                        }
                        }
                          style={claim?.status_update === "Pending" ?
                            { cursor: 'not-allowed', color: '#9e9e9e', borderColor: '#9e9e9e' }
                            :
                            {}
                          }>
                          View
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="no_content_notice_contain">
                  {search === "" ? (
                    <div className="programs_no_res_main">No claims found</div>
                  ) : (
                    <div className="programs_no_res_main">No such patient found in claims</div>
                  )}
                </div>
              )
            ) : (
              <div className="no_content_notice_contain">
                <div className="p_load"></div>
              </div>
            )}
          </div>
        </div>
      </div>
      {isModalOpen && selectedClaim && (
        <div className="claim-modal-overlay" onClick={closeModal}>
          <div className="claim-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="claim-modal-header">
              <h2>Claim Details</h2>
              <IconButton onClick={closeModal}>
                <X />
              </IconButton>
            </div>
            <div className="claim-modal-body">
              <div className="claim-modal-section">
                <h3>Patient Information</h3>
                <div className="claim-modal-grid">
                  <div className="claim-modal-field">
                    <label>Patient Name:</label>
                    <span>{selectedClaim.patient_name}</span>
                  </div>
                  {/* <div className="claim-modal-field">
                    <label>Patient Account Number:</label>
                    <span>{selectedClaim.patient_account_number}</span>
                  </div> */}
                </div>
              </div>

              <div className="claim-modal-section">
                <h3>Claim Information</h3>
                <div className="claim-modal-grid">
                  {/* <div className="claim-modal-field">
                    <label>Claim ID:</label>
                    <span>{selectedClaim.claim_id}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Transaction ID:</label>
                    <span>{selectedClaim.transaction_id}</span>
                  </div> */}
                  <div className="claim-modal-field">
                    <label>Clearinghouse Trace Number:</label>
                    <span>{selectedClaim.clearinghouse_trace_number}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>CPT Code:</label>
                    <span>{selectedClaim.cpt_code}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Diagnosis:</label>
                    <span>{selectedClaim.diagnosis}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Recovery Plan:</label>
                    <span>{selectedClaim.recovery_plan}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Physical Therapist:</label>
                    <span>{selectedClaim.physical_therapist}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Total Charge Amount:</label>
                    <span>${selectedClaim.total_claim_charge_amount.toFixed(2)}</span>
                  </div>
                </div>
              </div>

              <div className="claim-modal-section">
                <h3>Status Information</h3>
                <div className="claim-modal-grid">
                  <div className="claim-modal-field">
                    <label>Status:</label>
                    <span>{selectedClaim.status_update}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Status Explanation:</label>
                    <span>{selectedClaim.status_explanation}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Status Updated At:</label>
                    <span>
                      {moment(selectedClaim.status_updated_at).format("MMMM Do YYYY, h:mm a")}
                    </span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Status Effective Date:</label>
                    <span>{moment(selectedClaim.status_effective_date).format("MMMM Do YYYY")}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Category Code:</label>
                    <span>{selectedClaim.category_code}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Category Description:</label>
                    <span>{selectedClaim.category_description}</span>
                  </div>
                </div>
              </div>

              <div className="claim-modal-section">
                <h3>Service Information</h3>
                <div className="claim-modal-grid">
                  <div className="claim-modal-field">
                    <label>Service Begin Date:</label>
                    <span>{moment(selectedClaim.service_begin_date).format("MMMM Do YYYY")}</span>
                  </div>
                  <div className="claim-modal-field">
                    <label>Service End Date:</label>
                    <span>{moment(selectedClaim.service_end_date).format("MMMM Do YYYY")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ApprovedClaims

